import React, {ReactElement, useState} from 'react';
import {
  DialogLegacy as Dialog,
  DialogLegacyContent as DialogContent,
  DialogLegacyActions as DialogActions,
  Button,
  Typography,
  Alert
} from '@customink/pigment-react';

type DialogProps = {
  open: boolean;
  title: string;
  alertContent?: string;
  descriptionContent?: string;
  closeText?: string;
  confirmText: string;
  handleConfirm: () => void;
  handleClose: () => void;
};

const SettingDialog: React.FC<DialogProps> = ({
  open,
  title,
  alertContent,
  descriptionContent,
  closeText,
  confirmText,
  handleConfirm,
  handleClose
}: DialogProps): ReactElement => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <Dialog
      className="settingDialog"
      title={title}
      open={open}
      maxWidth="md"
      onClose={handleClose}>
      <DialogContent>
        {alertContent ? (
          <Alert severity="error" className="dialogAlert">
            {alertContent}
          </Alert>
        ) : null}
        {descriptionContent ? (
          <Typography className="description">{descriptionContent}</Typography>
        ) : null}
      </DialogContent>
      <DialogActions className="settingDialog-actions">
        {closeText ? (
          <Button
            size="large"
            variant="secondary"
            type="submit"
            onClick={handleClose}>
            {closeText}
          </Button>
        ) : null}
        <Button
          size="large"
          type="submit"
          disabled={isSubmitting}
          onClick={async () => {
            if (isSubmitting) return;
            setIsSubmitting(true);
            try {
              await handleConfirm();
            } catch (error) {
              console.error('Confirmation failed:', error);
            } finally {
              setIsSubmitting(false);
            }
          }}>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

SettingDialog.defaultProps = {
  alertContent: undefined,
  descriptionContent: undefined,
  closeText: undefined
};

export default SettingDialog;
